import * as React from 'react';
import {
  // eslint-disable-next-line no-restricted-imports
  Checkbox as MuiCheckbox,
  // eslint-disable-next-line no-restricted-imports
  Radio as MuiRadio,
  RadioProps as MuiRadioProps,
} from '@material-ui/core';
import {
  checkboxBase,
  muiInputIconStyles,
  radioBase,
} from 'omakase/SelectionControls/selectionControlsCssDefs';

export type RadioCoreType = 'radio' | 'checkbox';

interface RadioCoreBaseProps {
  type: RadioCoreType;
  'data-testid'?: string;
}

export type SelectionControlsCoreProps = Pick<
  MuiRadioProps,
  Exclude<keyof MuiRadioProps, 'color' | 'size' | 'type'>
>;

/**
 * Shared implementation for RadioButton and Checkbox.
 * Should not be used directly in production.
 */
const SelectionControlsCore: React.FunctionComponent<
  SelectionControlsCoreProps & RadioCoreBaseProps
> = ({ 'data-testid': dataTestId, type, ...rest }) => {
  const isRadio = type === 'radio';
  const Component = isRadio ? MuiRadio : MuiCheckbox;

  return (
    <Component
      css={isRadio ? radioBase : checkboxBase}
      color="primary"
      disableRipple
      icon={<span css={muiInputIconStyles} />}
      checkedIcon={<span css={muiInputIconStyles} />}
      // https://github.com/mui/material-ui/issues/20160 - TypeScript limitation currently prevents MUI's component from accepting this prop
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      inputProps={{ 'data-testid': dataTestId }}
      {...rest}
    />
  );
};

export default SelectionControlsCore;
